import { render, staticRenderFns } from "./Rify.vue?vue&type=template&id=9b86cbd2&scoped=true"
import script from "./Rify.vue?vue&type=script&lang=js"
export * from "./Rify.vue?vue&type=script&lang=js"
import style0 from "./Rify.vue?vue&type=style&index=0&id=9b86cbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b86cbd2",
  null
  
)

export default component.exports